import useAuth from "../../hooks/useAuth";
import "./LoadingIndicator.css";

const LoadingIndicator = () => {
  const { user } = useAuth()
  return (
    <div
      duration={2}
      delay={0.5}
      animationRepeat="once"
      className="loading-container"
    >
      <section>
        <div className="loading loading02">
          {user ? <span>{`Welcome ${user.username}`}</span> : <span>ArtistNextDoor</span>}

        </div>
      </section>
    </div>
  );
};

export default LoadingIndicator;
